import { useDispatch } from "react-redux";
import { AESDecryption } from "../../utils/Aes";
import { decodeToken, isExpired } from "react-jwt";
import { loginSuccess, logout } from "../../redux/slices/authSlice";
import { Navigate } from "react-router-dom";

const RequireJWT = ({ children }) => {
    const dispatch = useDispatch();
    let isExpiredValue = false;
    const encryptedToken = localStorage.getItem('token');
    const encryptedCompanyId = localStorage.getItem('companyId');

    if(encryptedToken){
      const token = AESDecryption(encryptedToken);
      const decCompanyId = AESDecryption(encryptedCompanyId);
      const companyId = parseInt(decCompanyId)
  
            
      const DecodedToken = decodeToken(token);
      const isTokenExpired = isExpired(token);
      if(isTokenExpired){
        isExpiredValue = true;
        dispatch(logout());
        sessionStorage.setItem('sessionExpired', 'true'); 
      }else{
        const selectedCompany = DecodedToken.companyData.find(company => company.companyId === companyId);
        const roles = selectedCompany?.roles || [];
        const userDetailsId = selectedCompany?.userDetailsId;
        
        const payload = {
          token : token,
          userCompany : DecodedToken,
          companyId : companyId,
          role: roles,
          userDetailsId: userDetailsId
        }
        dispatch(loginSuccess(payload));
        isExpiredValue=false
       }
       return !isExpiredValue ? children : <Navigate to="/login" replace />;
    }else{
        return <Navigate to="/login" replace />;
    }
};

export default RequireJWT;
    